module.exports = __webpack_public_path__ + "img/partner_supplier_channel1.c37aae36.png";